import { render } from "./PopupConfirm.vue?vue&type=template&id=0d01aa37"
import script from "./PopupConfirm.vue?vue&type=script&lang=js"
export * from "./PopupConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__